var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon svg-icon--close",attrs:{"width":"18","height":"16","viewBox":"0 0 18 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M18 1.56L16.244 0 9 6.439 1.756 0 0 1.56 7.244 8 0 14.438 1.756 16 9 9.56 16.244 16 18 14.439l-7.244-6.44z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }